export default __webpack_public_path__ + "static/media/right-glow.c9e4f70d.png";